import * as React from "react";
import { IssueBriefModel } from "../../model/autogen/IssueBriefModel";
import { DocumentItem } from "../../model/autogen/DocumentItem";
import { RenderDocumentItemDisplay } from "./common";

export function renderBriefContents(sortedItems: DocumentItem[], item: IssueBriefModel) {
    return <div>
        {sortedItems.map((si) => RenderDocumentItemDisplay(si))}
    </div>;
}


// WEBPACK FOOTER //
// ./src/components/display/brief-display.tsx